import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsSection {
    export const componentId = 'section';

    export interface IColumn {
        size: number;
        components: NICmsContentComponent.IData[];
    }

    export interface IComponentData extends NICmsContentComponent.IData {
        items?: IColumn[];
        gap: number;
    }
}
const gridSize = 12;

@ICmsComponent<CmsSectionComponent>({
    id: NCmsSection.componentId,
    name: 'Section',
    isAdvanced: true,
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Columns',
            itemName: 'Column',
            defaultSize: 1,
            minSize: 1,
            maxSize: 12,
            fields: [
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'size',
                    title: 'Size',
                    required: true,
                    options: Array.from(Array(gridSize + 1).keys())
                        .map(i => i)
                        .map(number => {
                            return { key: number, title: `${number}` };
                        }),
                    default: 1
                },
                <NICmsContentField.IComponentsField>{
                    type: NICmsContentField.EFieldType.components,
                    key: 'components',
                    title: 'Components'
                    // default: []
                }
            ],
            default: [
                { size: 6, components: [] },
                { size: 6, components: [] }
            ]
        },
        <NICmsContentField.INumberField>{
            type: NICmsContentField.EFieldType.number,
            key: 'gap',
            title: 'Grid Gap',
            min: 0,
            max: 12,
            required: true,
            default: 0
        },
        NICmsContentComponent.backgroundField
    ],
    priority: 50
})
@Component({
    selector: 'cms-section',
    templateUrl: './cms-section.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsSectionComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsSection.IComponentData;

    readonly gridSize = gridSize;

    get columns(): NCmsSection.IColumn[] | undefined {
        if (this.component) {
            let total = 0;
            return this.component.items?.filter(item => {
                if (!item.size) {
                    return false;
                }
                total += item.size;
                return total <= gridSize;
            });
        }
        return undefined;
    }

    protected trackByFn(item: NCmsSection.IColumn) {
        return item;
    }
}
